import React from "react";
import ProductGrid from "./components/ProductGrid";

function HealthyAging() {
  return <ProductGrid params={{ skinConcern: "aging" }} />;
}

export default HealthyAging;
